/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types,jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  changeFieldFeedbackTopicsId,
  changeFieldCustomTopic,
  changeFieldContent,
  selectFieldFeedbackTopicsId,
  selectFieldCustomTopic,
  selectFieldContent,
  selectRequestState,
  selectFeedbackTopics,
  sendRequest
} from 'mt-react-common/modules/feedback/reducers/static/forms/sendFeedback/sendFeedbackForm';

import OpacityPreLoader from 'components/Common/PreLoaders/OpacityPreLoader';
import DefaultSelect from '../../Common/Inputs/DefaultSelect';

const sendFeedbackForm = 'feedbackModule.forms.sendFeedbackForm';

class FeedbackPopUp extends Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.requestState.hasSuccessQuery !==
        this.props.requestState.hasSuccessQuery &&
      this.props.requestState.hasSuccessQuery
    ) {
      this.props.handleClose();
    }
  }
  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <div
        className="modal-dialog"
        role="document"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header text-center">
            <a
              href=""
              className="close close-black"
              onClick={this.props.handleClose}
            />
            <i className="fa fa-comments modal-icon" />
            <h4 className="modal-title">{t('Обратная связь')}</h4>
            <p>{t('Обратная связь')}</p>
          </div>
          <form>
            {this.props.requestState.hasInProgress ? (
              <OpacityPreLoader />
            ) : null}
            <div>
              <div className="modal-body">
                <div
                  className={`form-group ${
                    hasError(this.props.fieldFeedbackTopicsId.errors)
                      ? 'has-error'
                      : ''
                  }`}
                >
                  <label className="control-label" htmlFor="none">
                    {t('Тема сообщения')}:
                  </label>
                  <DefaultSelect
                    selectArrItems={Object.keys(
                      this.props.selectFeedbackTopics
                    ).map(key => ({
                      value: key,
                      title: this.props.selectFeedbackTopics[key]
                    }))}
                    value={this.props.fieldFeedbackTopicsId.value}
                    handleChangeValue={value => {
                      this.props.changeFieldFeedbackTopicsId(value);
                    }}
                  />
                  {errorDesc(this.props.fieldFeedbackTopicsId.errors)}
                </div>
                {this.props.fieldFeedbackTopicsId.value === '-1' ? (
                  <div
                    className={`form-group ${
                      hasError(this.props.fieldCustomTopic.errors)
                        ? 'has-error'
                        : ''
                    }`}
                  >
                    <label
                      className="control-label sr-only"
                      htmlFor="feedbackAnotherSubject"
                    >
                      {t('Другая тема сообщения')}:
                    </label>
                    <input
                      className="form-control"
                      placeholder={t('Введите тему сообщения')}
                      type="text"
                      value={this.props.fieldCustomTopic.value}
                      onChange={e => {
                        this.props.changeFieldCustomTopic(e.target.value);
                      }}
                    />
                    {errorDesc(this.props.fieldCustomTopic.errors)}
                  </div>
                ) : null}

                <div
                  className={`form-group m-b-0 ${
                    hasError(this.props.fieldContent.errors) ? 'has-error' : ''
                  }`}
                >
                  <label
                    className="col-sm-2 control-label"
                    htmlFor="feedbackContent"
                  >
                    {t('Сообщение')}
                  </label>
                  <textarea
                    id="feedbackContent"
                    className="form-control"
                    maxLength="2000"
                    minLength="10"
                    rows="3"
                    value={this.props.fieldContent.value}
                    onChange={e => {
                      this.props.changeFieldContent(e.target.value);
                    }}
                  />
                  {errorDesc(this.props.fieldContent.errors)}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-muted"
                  type="button"
                  onClick={this.props.handleClose}
                >
                  {t('Отмена')}
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={this.props.sendRequest}
                >
                  {t('Отправить')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

FeedbackPopUp.propTypes = {
  // IN
  handleClose: PropTypes.func.isRequired,

  // CONNECT
  selectFeedbackTopics: PropTypes.shape({}).isRequired,
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  fieldFeedbackTopicsId: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldCustomTopic: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldContent: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,

  changeFieldFeedbackTopicsId: PropTypes.func.isRequired,
  changeFieldCustomTopic: PropTypes.func.isRequired,
  changeFieldContent: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  selectFeedbackTopics: selectFeedbackTopics(state),
  requestState: selectRequestState(state, sendFeedbackForm),
  fieldFeedbackTopicsId: selectFieldFeedbackTopicsId(state, sendFeedbackForm),
  fieldCustomTopic: selectFieldCustomTopic(state, sendFeedbackForm),
  fieldContent: selectFieldContent(state, sendFeedbackForm)
});

const mapDispatchToProps = dispatch => ({
  changeFieldFeedbackTopicsId: value =>
    dispatch(changeFieldFeedbackTopicsId(sendFeedbackForm, value)),
  changeFieldCustomTopic: value =>
    dispatch(changeFieldCustomTopic(sendFeedbackForm, value)),
  changeFieldContent: value =>
    dispatch(changeFieldContent(sendFeedbackForm, value)),
  sendRequest: value => dispatch(sendRequest(sendFeedbackForm, value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedbackPopUp);



// WEBPACK FOOTER //
// ./src/components/Feedback/FeedbackPopUp/FeedbackPopUp.js